module.exports = __webpack_public_path__ + "d6f681346a7930fc80e27e92dd13da8e.pdf";